import React from 'react';
import AppliedFilter from './applied-filter';
import ClearButton from '../clear-button';
import * as S from './styles';
import { ProductCollectionNonNameSearchFilter } from '../types';

type Props = {
  title?: string;
  filters: ProductCollectionNonNameSearchFilter[];
  clearFilter: (property?: string) => void;
};

const AppliedFilters = ({ filters, title, clearFilter }: Props) => {
  return filters && filters.length > 0 ? (
    <S.AppliedFilters>
      {!!title && <S.AppliedFiltersTitle>{title}</S.AppliedFiltersTitle>}
      {filters.map(filter => (
        <AppliedFilter key={filter.property} filter={filter} />
      ))}
      <ClearButton
        clearFilter={clearFilter}
        variant="text"
        color="negative"
        size="small"
      />
    </S.AppliedFilters>
  ) : null;
};

export default AppliedFilters;
